<div class="theme-form">
    <div class="back">
        <button type="button" routerLink="/admin/themes">
            <span class="icon-anchor-top"></span>
            <span>Back to Theme Management</span>
        </button>
    </div>

    <h3 class="title">{{ title() }}</h3>

    <form [formGroup]="form">
        <div class="name-field">
            <tools-input-outline
                label="NAME"
                placeholder="Enter a short name for this theme (listeners won't see this)"
                [maxLength]="maxLength"
                formControlName="name"
            ></tools-input-outline>
        </div>

        <section class="section">
            <h4 class="section-title">Interactive Studio Controls</h4>
            <p class="section-subtitle">
                Key settings for AI engine behavior and producer-side styling.
            </p>

            <mat-tab-group [preserveContent]="true">
                <mat-tab label="Display">
                    <app-theme-display
                        [display]="form.controls.display"
                    ></app-theme-display>
                </mat-tab>
                <mat-tab label="PWA">
                    <app-theme-pwa [pwa]="form.controls.pwa"></app-theme-pwa>
                </mat-tab>
                <mat-tab label="Responses">
                    <app-theme-responses
                        [responses]="form.controls.responses"
                    ></app-theme-responses>
                </mat-tab>
                <mat-tab label="AI Prompts">
                    <app-theme-ai-filters
                        [ai]="form.controls.ai"
                    ></app-theme-ai-filters>
                </mat-tab>
                <mat-tab label="AI Evaluation">
                    <app-theme-ai-evaluation
                        [ai]="form.controls.ai"
                    ></app-theme-ai-evaluation>
                </mat-tab>
            </mat-tab-group>
        </section>
    </form>

    <div class="action-bar">
        <tools-button
            [variant]="ButtonVariant.OUTLINE"
            routerLink="/admin/themes"
        >
            Cancel
        </tools-button>
        <tools-button [isDisabled]="isSubmitDisabled()" (onClick)="onSubmit()">
            {{ primaryLabel() }}
        </tools-button>
    </div>
</div>
